import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './CalendarLoadFallback.css';

export const CalendarLoadFallback: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Spinner size={24} />
    </div>
  );
};
